/** API origin from env, no trailing slash (e.g. http://localhost:3001). */
export const API_URL = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

/** REST API v1 base URL built from VITE_API_URL. */
export const API_V1_BASE = `${API_URL}/api/v1`;
